import { useState } from 'react'
import { Grid, Typography } from '@mui/material'

import NextQuestionIcon from '@mui/icons-material/KeyboardArrowRight'

import { CertificateQuestion, CertificateQuestionAnswerType } from 'src/types/CertificateQuestion'
import AsyncButton from 'src/components/Utils/AsyncButton/AsyncButton'
import { getInitialAnswer, renderQuestionAnswers } from './answers'
import styled from 'styled-components'
import { useMediaSignedUrl } from 'src/hooks/useMediaSignedUrl'
import QuestionImageDialog from './QuestionImageDialog'

const StyledImage = styled.img`
    border-radius: 10px;
    width: 50%;
    height: 300px;
    object-fit: fill;
    cursor: pointer;
`

const StyledGrid = styled(Grid)`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

type CertificateQuizQuestionProps = {
    question: CertificateQuestion
    onAnswer: (answer: CertificateQuestionAnswerType) => Promise<void>
}

export function CertificateQuizQuestion({ question, onAnswer }: CertificateQuizQuestionProps) {
    const [isImgDialogOpen, setIsImgDialogOpen] = useState(false)

    const [isValidAnswer, setIsValidAnswer] = useState(false)
    const [answer, setAnswer] = useState(getInitialAnswer(question.type))

    const onUpdateAnswer = (answer: CertificateQuestionAnswerType, isValidAnswer: boolean) => {
        setAnswer(answer)
        setIsValidAnswer(isValidAnswer)
    }

    const questionImage = useMediaSignedUrl(question.image ?? null)

    const handleCloseImgDialog = () => {
        setIsImgDialogOpen(false)
    }

    const handleOpenImgDilaog = () => {
        setIsImgDialogOpen(true)
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography variant="h5">{question.questionText}</Typography>
            </Grid>
            <StyledGrid item xs={12}>
                {questionImage && (
                    <>
                        <StyledImage src={questionImage} alt="questionImage" onClick={handleOpenImgDilaog} />
                        <QuestionImageDialog isOpen={isImgDialogOpen} onClose={handleCloseImgDialog} imgUrl={questionImage} />
                    </>
                )}
            </StyledGrid>
            <Grid item xs={12}>
                {renderQuestionAnswers(question, answer, onUpdateAnswer)}
            </Grid>
            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                <AsyncButton disabled={!isValidAnswer} variant="contained" size="large" onClick={() => onAnswer(answer)}>
                    <NextQuestionIcon />
                    Nächste Frage
                </AsyncButton>
            </Grid>
        </Grid>
    )
}
